export const environment = {
  production: true,
  env: 'demo',
  apiHost: 'https://api.uat.muni.spglobal.com',
  muniApiHost: 'https://api.staging.muni.ipreo.com',
  dealUpdateChannel: 'casa-muni-deal-updates-demo',
  appName: 'muni-gameday-direct-demo',

  polaris: {
    env: 'staging',
    registryUrl: 'https://registry.staging.browsermodules.ihsmarkit.com',
    apiBaseUrl: 'https://api.staging.polaris.ihsmarkit.com',
    wsUrl: 'wss://gateway.staging.sockets.ipreo.com/connect',
    logInterval: 30000
  }
};
